import { createSelector } from 'reselect';
import IState from '../state';

export const isExportGenerating = ({ chat }: IState) => chat.exportGenerating;
export const getSilencedUsers = createSelector(
  ({ chat }: IState) => chat.silencedUsers,
  silencedUsers => silencedUsers,
);
export const getAnonUsername = (state: IState) => state.chat.anonUsername;
